var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84348 3.6254L3.37015 9.41874C3.16348 9.63874 2.96348 10.0721 2.92348 10.3721L2.67682 12.5321C2.59015 13.3121 3.15015 13.8454 3.92348 13.7121L6.07015 13.3454C6.37015 13.2921 6.79015 13.0721 6.99681 12.8454L12.4701 7.05207C13.4168 6.05207 13.8435 4.91207 12.3701 3.51874C10.9035 2.13874 9.79015 2.6254 8.84348 3.6254Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 4.59375C8.21635 6.43375 9.70969 7.84042 11.563 8.02708",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.637dcd2043f2d34c485436729ddf4cd4.svg";
export { ForwardRef as ReactComponent };